


































































































































































interface ProductSelectValue {
  id: string;
  title: string;
  is506c?: boolean;
}

import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import Header from "@/types/app/header";
import SubDocumentInvestorsInterface, {
  InvestorCompleteInterface,
  SubdocumentsFilesI,
} from "@/types/app/subdocument";
import CustomerProduct from "@/components/headers/customer-products";
import ModalInvestorDetail from "@/components/common/ModalInvestorDetail.vue";
import ModalSendContract from "@/views/subdocs/sendContract.vue";
import formatDate from "@/utils/formatDate";
import applyCondition from "@/utils/applyCondition";
import Endpoint from "@/utils/endpoint";
import { getFileNameFromLink } from "@/utils/fileName";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import compareTo from "@/utils/compareTo";
import Product from '@/types/app/products';
import { Getter } from "vuex-class";

@Component({
  components: { ModalInvestorDetail, ModalSendContract },
  
})
export default class Subdocument extends BaseComponent {

  @Getter('getOnlyPublished', { namespace: 'product' })
  products!: Product[];

  headers: Header[] = CustomerProduct.headerSubdocumentUsers;
  investors: SubDocumentInvestorsInterface[] = [];
  nameFilter = "";
  emailFilter = "";
  loading = false;
  loadingSubdocsFiles = false;
  investorDetail = {};
  openInvestorDetailModal = false;
  openSendContractModal = false;
  subdocumentsFiles: SubdocumentsFilesI[] = [];
  selectedInvestors = [];
  selectedFileToFill: any = {};
  statusFormFillColor = {
    "Not Started": "not-started",
    "Filling in": "filling-in",
    Filled: "filled",
  };
  productsSelect: VuetifySelectItems[] = [];
  productId = "";

  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
                  
  private endpoint = new Endpoint();
                          
 async mounted() {
    const [productsResponse] = await Promise.all([this.getProducts()]);  
    this.productsSelect = productsResponse;

      if (this.$route.query.productId){
        this.productId = this.$route.query.productId.toString();
        this.loadingSubdocs();
      }
  }
  


  
  getSelectedInvestors(selectedInvestors: InvestorCompleteInterface) {
    this.openInvestorDetailModal = false;
    this.openSendContractModal = false;
  }

  @Watch("productIdView")
  async loadingSubdocs(){
    await Promise.all([this.fetchSubdocumentsFiles(), this.fetchInvestorsSubdocuments()]);
  }

  get disabledSendToFill(): boolean {
    return this.loading || (this.subdocumentsFiles?.length ?? 0) == 0
      || (!this.selectedFileToFill?.fileId) || (this.selectedInvestors?.length ?? 0) === 0;
  }

  async fetchSubdocumentsFiles() {
    this.loadingSubdocsFiles = true;
    if (this.productId)
      try {
        const { data: subdocsFiles } = await this.$http.get(
          `${this.endpoint.listSubDocumentsFiles}/${this.productId}`
        );

        this.subdocumentsFiles = subdocsFiles;
      } catch (error) {
        console.error("fetchSubdocumentsFiles", error);
      } finally {
        this.loadingSubdocsFiles = false;
      }
  }

  async createSubdocumentFile(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    this.loadingSubdocsFiles = true;
    const filesize = Number.parseInt(((file.size / 1024) / 1024).toFixed(0)); // MB
    if (filesize >= 10) {
      this.showError(`Pdf size too large  ${filesize}`);
      return false;
    }
    try {
      await this.$http.post(
        `${this.endpoint.uploadSubDocumentsFile}/${this.productId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.fetchSubdocumentsFiles();
    } catch (error) {
      console.error("createSubdocumentFile", error);
    } finally {
      this.loadingSubdocsFiles = false;
    }
  }

  
   async getProducts(): Promise<VuetifySelectItems[]> {
    this.loadingSubdocsFiles = true;
    try{
      this.products
      const productFundsOrdened = this.products.sort((a, b) =>
        compareTo(a.title, b.title)
      );

      const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
        text: productFund.title,
        value: productFund.id,
        data: productFund,
      }));

      return itemsForVuetifySelect;
    } finally{
      this.loadingSubdocsFiles = false;
    }
    
  }

  async deleteSubdocumentFile(file: SubdocumentsFilesI) {
    this.loadingSubdocsFiles = true;

    try {
      await this.$http.delete(`${this.endpoint.deleteSubDocumentsFile}`, {
        data: {
          urlFile: file.url,
          productId: this.productId,
        },
      });

      this.fetchSubdocumentsFiles();
    } catch (error) {
      console.error("deleteSubdocumentFile", error);
    } finally {
      this.loadingSubdocsFiles = false;
    }
  }

  async fetchInvestorsSubdocuments() {
    this.loading = true;
    if (this.productId)
      try {
        const { data } = await this.$http.get(
          `${this.endpoint.investments}/${this.productId}`
        );
       const formsField =  data.map((x:any) => 
          { 
            
            return x.formsField.map((f:any) =>  {
            return { idFormField: f.idFormField, 
                  status: f.status, 
                  perfilName: f.perfilName, 
                  perfilType: f.perfilType, 
                  email: x.email, 
                  name: x.fullName, 
                  subDocsFilled: x.subDocsFilled,
                  country: x.country,
                  phone: x.phone,
                  userId: x.userId,
                  nonUs: f.nonUs,
                dateCreatedUser: x.dateCreatedUser
            }}); 
          }
        )
       
        this.investors = formsField.flat(Infinity);
      } catch (error) {
        console.error("fetchInvestorsSubdocuments", error);
      } finally {
        this.loading = false;
      }
  }

  openInvestorDetail(data: InvestorCompleteInterface) {
    this.investorDetail = data;
    this.openSendContractModal = false;
    this.openInvestorDetailModal = true;
  }

  openSendContract() {
    this.openInvestorDetailModal = false;
    this.openSendContractModal = true;
  }

  get filteredInvestorsTable() {
    const conditions: any[] = [];

    if (this.nameFilter) {
      conditions.push((item: SubDocumentInvestorsInterface) =>
        item.name.toLowerCase().includes(this.nameFilter.toLowerCase())
      );
    }
    if (this.emailFilter) {
      conditions.push((item: SubDocumentInvestorsInterface) =>
        item.name.toLowerCase().includes(this.emailFilter.toLowerCase())
      );
    }

    return applyCondition<SubDocumentInvestorsInterface>(
      this.investors,
      conditions
    );
  }

  async sendToFill() {
    this.loading = true;
    try {
      const body = {
        userIds: this.selectedInvestors.map(
          (investor: InvestorCompleteInterface) => investor.userId
        ),
        formFieldId: (this.selectedInvestors[0] as any).idFormField,
        productId: this.productId,
        onlyFilled: true,
        filePath: this.selectedFileToFill.url,
        fileName: this.selectedFileToFill.title
      };

      const result = await this.$http.post(this.endpoint.sendSubdocumentContract, body);
      if ((result as any)?.hasErrors || result.data?.hasErrors) {

        this.logHttpError(result);
        this.loading = false;
      }
      else {
        this.showSuccess('Subdocument filled successfully!');
        await this.fetchInvestorsSubdocuments();
        this.loading = false;
      }
    }
    catch (ex) {
      this.logException(ex);
      this.loading = false;
    }


  }
}
